import React from "react";
import { Grid, TextField } from "@mui/material";
import "./forgotPassword.scss";
import { useFormik } from "formik";
import loginIcon from "../../assets/authentication-imgs/main-logo.svg";
import * as Yup from "yup";
import errorIcon from "../../assets/authentication-imgs/error-icon.svg";
import { Link } from "react-router-dom";
import { useAppDispatch } from "../../store/store";
import { forgotPasswordFetch } from "./features/function";

const ForgotPassword: React.FC = () => {
  const dispatch = useAppDispatch();
  const initialSchema = {
    email: "",
  };
  const validate = Yup.object({
    email: Yup.string()
      .required("Email is required")
      .email("We could'nt find an account with that email address"),
  });
  const handleForgotPassword = async (values: any) => {
    const forgotPasswordDispatch: any = await dispatch(
      forgotPasswordFetch(values)
    );
  };

  const { values, touched, errors, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialSchema,
      validationSchema: validate,
      onSubmit: handleForgotPassword,
    });
  return (
    <div className="forgot-password">
      <Grid container>
        <Grid  item md={6}   lg={6}  xl={5} sx={{ display: { xs: "none", md: "block" } }}
        >
          <div className="forgot-background"></div>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={7}>
          <div className="forgot-main flex-center-center flex-column ">
            <div className=" logo">
              <img src={loginIcon} />
            </div>
            <div className="forgot-conetent">
              <h2 className="forgot-title h1 fw-700  ">Forgot Password</h2>
              <p className="h5">
                Enter the email assosiated with your account and we’ll send an
                email with instructions to reset your password.
              </p>
            </div>
            <form className="form d-flex flex-column " onSubmit={handleSubmit}>
              <TextField
                sx={{ margin: "30px 0 20px 0" }}
                fullWidth
                size="small"
                type="email"
                id="email"
                variant="outlined"
                placeholder="Email"
                error={!!(errors.email && touched.email)}
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.email && touched.email && (
                <span className="error-message">
                  <img src={errorIcon} />
                  <small>{errors.email}</small>
                </span>
              )}
              <button className="btn btn-primary" type="submit">
                Continue
              </button>
            </form>
            <div className="footer">
              <span className="brown-text">Back to </span>
              <Link to="/signin">
                <span className="yallow-text cursor-pointer">Login</span>
              </Link>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ForgotPassword;
